<template>
  <div>
    <van-tabbar v-model="active" :active-color="GetColorMain()" style="z-index: 10;" @change="onChange">
      <van-tabbar-item to="/dive">
        <span>潜水</span><br>
        <i slot="icon" class="iconfont icondiveer" />
      </van-tabbar-item>
      <van-tabbar-item to="/store/index">
        <span>商城</span><br>
        <i slot="icon" class="iconfont iconstorebag" />
      </van-tabbar-item>
      <van-tabbar-item to="/divetrip">
        <span>行程</span><br>
        <i slot="icon" class="iconfont icontrip" />
      </van-tabbar-item>
      <van-tabbar-item to="/divegroup">
        <span>圈子</span><br>
        <i slot="icon" class="iconfont iconquanzi" />
      </van-tabbar-item>
      <van-tabbar-item to="/dive/my">
        <span>我的</span><br>
        <i slot="icon" class="iconfont icondivemy" />
      </van-tabbar-item>
      <van-tabbar-item v-if="showProItem" to="/pro/index">
        <span>专业</span><br>
        <i slot="icon" class="iconfont iconmian_pro1" />
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>
<script>
import commonData from '@/commondata.js'
// import request from '@/utils/request'
import { Tabbar, TabbarItem, CountDown, Overlay, Button } from 'vant'
import { getUrlKey, getUserBase, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [CountDown.name]: CountDown,
    [Overlay.name]: Overlay,
    [Button.name]: Button
  },
  props: {
    value: undefined
  },
  data() {
    return {
      active: 0,
      shoppingCarNum: 0,
      showProItem: false,
      system: undefined
    }
  },
  watch: {
    value(newValue) {
      this.active = newValue
    }
  },

  created() {
    this.shoppingCarNum = commonData.shoppingCarNum
    this.active = this.value
    this.system = getUrlKey('system')
    getUserBase(data => {
      console.log('用户数据', data)
      if (data && data.proAccountId) {
        this.showProItem = true
      }
    }, true)
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onChange(index) {
      this.$emit('input', index)
    }
  }
}
</script>
<style scoped>
.ActivityIcon{
  position:fixed;
  right: 0;
  top: 60%;
  width: 5.5em;
  background-color:rgba(79, 97, 115, 0.8);
  font-size: 0.7em;
  text-align: center;
  color: #EDC788;
  padding: 0.2em 0.2em;
  border-top-left-radius: 0.4em;
  border-bottom-left-radius: 0.4em;
  z-index: 100;
}
.ActivityIcon .rect{
  border:1px solid #EDC788;
  border-radius: 0.4em;
}
.ActivityIcon .rect div{
  padding-bottom: 0.3em;
}
.ActivityIcon img{
  border-bottom: 1px solid #EDC788;
  width: 100%;
  margin-top: 0.3em;
  padding-bottom:0.3em;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.wrapper div{
  width: 70%;
}
.wrapper img{
  width: 100%;
}

</style>
